import { State } from "../state/state";
import Utils from "../../../utils";

export const fromServer = (
  data: State.PowerSupplyServer
): State.PowerSupply => {
  return Object.assign({}, data, {
    v: Utils.scaleUx(data.v, 1),
    i: Utils.scaleUx(data.i, 1),
    vHigh: Utils.scaleUx(data.vHigh, 1),
    iHigh: Utils.scaleUx(data.iHigh, 1),
    vLow: Utils.scaleUx(data.vLow, 1),
    iLow: Utils.scaleUx(data.iLow, 1),
    Present: Utils.numToBool(data.Present)
  });
};

export const toServer = (
  data: Partial<State.PowerSupply>
): Partial<State.PowerSupplyServer> => {
  let bools: Partial<State.PowerSupplyServer> = Utils.convertBooleansToNumbers(
    data,
    ["Present"]
  );
  let server: Partial<State.PowerSupplyServer> = Utils.convertUxToServer(data, [
    "vHigh",
    "iHigh",
    "vLow",
    "iLow",
    "i",
    "ical",
    "ioff",
    "v",
    "vcal",
    "voff"
  ]);
  return Object.assign({}, data, bools, server);
};
